import Vue from 'vue'
import { Cascader, Popup, Field, Icon, Collapse, CollapseItem } from 'vant';
import 'vant/lib/index.css';
Vue.use(Cascader)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Icon);
Vue.use(Collapse);
Vue.use(CollapseItem);
